const debounce = require('../../../../../js-handler/debounce')
const dbRequest = require('../../../../../js-network/db-request')
const dtGenerator = require('../../../../../components/dt/dt-generator')
const dtSearchHandler = require('../../../../../components/dt/dt-search-handler')
const inf = require('../../../../../js-network/inf')
const snack = require('../../../../../components/snack/snack')

export function filter(detail, htmlDt) {
      if (dtSearchHandler.filterSeachCancel(htmlDt)) { return }

      debounce.start(() => {
            dtSearchHandler.cleanDt(htmlDt)
            select(detail, htmlDt, true)
      })
}

export function filterShowHide(detail, htmlDt) {
      if (dtSearchHandler.filterShowHide(htmlDt)) { return }

      dtSearchHandler.cleanDt(htmlDt)
      select(detail, htmlDt, true)
}

export function loadMore(detail, htmlDt) {
      if (dtSearchHandler.isDisableFooter(detail)) { return }

      dtSearchHandler.increaseFooter(htmlDt)
      select(detail, htmlDt, false)
}

export function searching(detail, htmlDt) {
      detail.ev.target.classList.add('searching')

      if (dtSearchHandler.searchCancel(htmlDt)) {
            detail.ev.target.classList.remove('searching')
            return
      }

      debounce.start(() => {
            dtSearchHandler.cleanDt(htmlDt)
            select(detail, htmlDt, true, () => {
                  detail.ev.target.classList.remove('searching')
            })
      })
}

export function th(detail, htmlDt) {
      dtSearchHandler.cleanDt(htmlDt)
      select(detail, htmlDt, false)
}

export function select(detail, htmlDt, cleanTable, callback, initialRows = 10) {
      inf.toSelect(detail, htmlDt)
      detail.inf.limit2 = initialRows
      htmlDt.entityDt.classList.add('dt-loading')

      dbRequest.start(detail, 'server/php/sql/retailSelect.php')
            .then((result) => {
                  if (result.status !== 'ok') { throw result }

                  const dataOrganized = htmlDt.organizeRow(result.data)
                  dtGenerator.addBody(dataOrganized, htmlDt, cleanTable)
                  dtSearchHandler.updateFooter(htmlDt, result.availableRowsWithFilters)
                  htmlDt.entityDt.classList.remove('dt-error')
                  htmlDt.entityDt.classList.remove('dt-loading')

                  if (callback !== undefined && callback !== null) { callback(result) }
            })
            .catch(() => {
                  snack.start({ act: 'show', id: 'downloadError' })
                  htmlDt.entityDt.classList.remove('dt-loading')
                  htmlDt.entityDt.classList.add('dt-error')
            })
}
